import React, { ReactNode, useRef } from 'react';
import MaterialCarousel from 'react-elastic-carousel';
import { v4 as uuid } from 'uuid';

// Material ui
import { Grid } from '@material-ui/core';

// Components
import CarouselIndicators from './CarouselIndicators';

// Style
import './Carousel.scss';

interface Props {
    children: ReactNode[];
    columns?: 1 | 2 | 3 | 4;
    rows?: number;
    initialActiveIndex?: number;
}

const handleNxNView = (children: ReactNode[], columns: number, rows: number) => {
    if(columns > 4) throw new Error('Max columns in the Carousel is 4');

    const nodeGroup = [];
    nodeGroup.push([ children[0] ]);

    for (let i = 1; i < children.length; i++) {
        nodeGroup[nodeGroup.length - 1].length % (rows * columns) === 0
            ? nodeGroup.push([ children[i] ])
            : nodeGroup[nodeGroup.length - 1].push(children[i]);
    }

    const xs = Math.floor(12 / columns) as 1 | 2 | 3 | 4;
    return nodeGroup.map((node: ReactNode[]) => (
        <Grid
            key={uuid()}
            container
            spacing={3}
        >
            {node.map((child: ReactNode) => (
                <Grid
                    key={uuid()}
                    item
                    xs={xs}
                >
                    {child}
                </Grid>
            ))}
        </Grid>
    ));
};

const Carousel: React.FC<Props> = ({
    children, columns = 2, rows = 2, initialActiveIndex = 0
}) => {
    const carouselRef = useRef<MaterialCarousel>();
    const carouselPages = useRef<number>();

    return (
        <>
            <MaterialCarousel
                ref={ref => carouselRef.current = ref}
                enableSwipe={false}
                enableMouseSwipe={false}
                isRTL={false}
                itemsToShow={1}
                initialActiveIndex={initialActiveIndex}
            >
                {handleNxNView(children, columns, rows)}
            </MaterialCarousel>
            <CarouselIndicators
                carouselPages={carouselPages}
                carousel={carouselRef}
            />
        </>
    );
};

export default Carousel;